import Vue from 'vue';
import vue from '@/main.js';

// 路由-服务
export default {
  /**
   * 跳转到某个页面
   *
   * @param pathOrName 命名的路由连接或名称
   * @param params 参数
   */
  push(pathOrName, params = {}) {
    if (pathOrName.charAt(0) == '/') {
      vue.$router.push({
        path: pathOrName,
        query: params
      });
    } else {
      vue.$router.push({
        name: pathOrName,
        params: params
      });
    }
  },

  /**
   * 返回页面
   *
   * @params delta 返回的页面数，如果 delta 大于现有页面数，则返回到首页。
   * @params timeInterval 延时跳转
   */
  pop(delta = 1, timeInterval = 0) {
    setTimeout(() => {
      vue.$router.go(-delta);
    }, timeInterval);
  },

  /**
   * 替换页面 - 这时候不会注入到history中
   *
   * @param pathOrName 命名的路由连接或名称
   * @param params 参数
   */
  replace(pathOrName, params = {}) {
    if (pathOrName.charAt(0) == '/') {
      vue.$router.replace({
        path: pathOrName,
        query: params
      });
    } else {
      vue.$router.replace({
        name: pathOrName,
        params: params
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/router.js